(function () {
    var autosuggestRequestPending = false;
    var autosuggestDisplayCache = { popularProducts: [], query: '' };

    var HEADER_SEARCH_INPUT_IDS = ['Search-In-Modal', 'Search-In-Modal-mobile'];
    var SUGGESTION_SEARCH_DOCTYPES = [
        'KEYWORD_SUGGESTION', 'INFIELD_SUGGESTION', 'TOP_SEARCH_QUERY', 'TOP_SEARCH_QUERIES', 'trending'
    ];
    var KEYWORD_SUGGESTION_DOCTYPES = [
        'KEYWORD_SUGGESTION', 'INFIELD_SUGGESTION', 'TOP_SEARCH_QUERIES', 'TOP_SEARCH_QUERY'
    ];
    var SUGGESTION_HOVER_DOCTYPES = [
        'INFIELD_SUGGESTION', 'KEYWORD_SUGGESTION', 'PROMOTED_SUGGESTION', 'TOP_SEARCH_QUERY', 'TOP_SEARCH_QUERIES'
    ];
    var SUGGESTION_SEARCH_DELAY_MS = 500;

    function forEachHeaderSearchInput(fn) {
        HEADER_SEARCH_INPUT_IDS.forEach(function (id) {
            var el = document.getElementById(id);
            if (el) fn(el, id);
        });
    }

    function refreshUnbxdAutosuggestReviews() {
        if (window.renderUnbxdKlaviyoReviews) {
            window.renderUnbxdKlaviyoReviews();
        }
    }

    function finishAutosuggestPanelUpdate(autosuggest) {
        ensureUnbxdAutosuggestPlacement(autosuggest);
        refreshUnbxdAutosuggestReviews();
    }

    function mountAutosuggestTemplate(autosuggest, template, state) {
        autosuggest.domService.updateSuggestionBoxHTML(template(state));
        autosuggest.domService.mountAutosuggestionBox();
        finishAutosuggestPanelUpdate(autosuggest);
    }

    function asPopularProductsList(products) {
        return Array.isArray(products) ? products : [];
    }

    function isUnbxdAutosuggestProductOutOfStock(product) {
        if (!product) return false;
        var a = product.availability;
        if (a === false || a === 'false' || String(a).toLowerCase() === 'false') return true;
        if (product.inStock === false || product.inStock === 'false') return true;
        if (product.unbxd_availability === 'false') return true;
        if (Array.isArray(product.variants) && product.variants.length > 0) {
            var anyAvailable = product.variants.some(function (variant) {
                if (!variant) return false;
                if (variant.availability === false || variant.availability === 'false') return false;
                var availableForSale = variant.v_availableForSale;
                return availableForSale === true
                    || availableForSale === 'true'
                    || availableForSale === 1
                    || availableForSale === '1';
            });
            if (!anyAvailable) return true;
        }
        return false;
    }

    window.isUnbxdAutosuggestProductOutOfStock = isUnbxdAutosuggestProductOutOfStock;

    function getDisplayPopularProducts(popularProducts) {
        var current = asPopularProductsList(popularProducts);
        if (current.length) return current;
        if (autosuggestRequestPending && autosuggestDisplayCache.popularProducts.length) {
            return autosuggestDisplayCache.popularProducts.slice();
        }
        return current;
    }

    function updateAutosuggestDisplayCache(popularProducts, query) {
        var list = asPopularProductsList(popularProducts);
        if (list.length) {
            autosuggestDisplayCache.popularProducts = list;
            autosuggestDisplayCache.query = query || '';
        } else {
            autosuggestDisplayCache.popularProducts = [];
            autosuggestDisplayCache.query = '';
        }
    }

    function getAutosuggestMinChars(autosuggest) {
        if (!autosuggest || !autosuggest.configManager) return 2;
        var minCharsConfig = autosuggest.configManager.getConfigs('inputBoxConfigs');
        return minCharsConfig && minCharsConfig.minChars != null ? minCharsConfig.minChars : 2;
    }

    function isAutosuggestQueryReady(query, autosuggest) {
        return normalizeUnbxdSearchQuery(query).length >= getAutosuggestMinChars(autosuggest);
    }

    function hideUnbxdAutosuggestPanel(autosuggest) {
        var box = (autosuggest && autosuggest.domService && autosuggest.domService.autosuggestionBox)
            || document.querySelector('.unbxd-autosuggest-result');
        if (box) box.classList.add('unbxd-as-panel-hidden');
        if (autosuggest && autosuggest.domService) {
            try { autosuggest.domService.unmountAutosuggestionBox(); } catch (err) {}
        }
        if (typeof window.jQuery !== 'undefined') {
            window.jQuery('body').removeClass('autosuggest_box_open');
        }
    }

    function clearUnbxdAutosuggestSubmitSuppress() {
        window.__unbxdSuppressAutosuggestPanel = false;
    }

    function closeUnbxdHeaderAutosuggestForSubmit(options) {
        options = options || {};
        window.__unbxdSuppressAutosuggestPanel = true;
        hideUnbxdAutosuggestPanel(window.unbxdHeaderAutosuggest);

        if (options.skipBlur) return;

        var inp = getActiveHeaderSearchInput();
        if (inp && document.activeElement === inp) {
            inp.blur();
        }
    }

    window.closeUnbxdHeaderAutosuggestForSubmit = closeUnbxdHeaderAutosuggestForSubmit;
    window.clearUnbxdAutosuggestSubmitSuppress = clearUnbxdAutosuggestSubmitSuppress;

    function normalizeUnbxdSearchQuery(value) {
        if (value == null) return '';
        if (Array.isArray(value)) {
            value = value.length ? value[0] : '';
        }
        while (Array.isArray(value)) {
            value = value.length ? value[0] : '';
        }
        if (typeof value !== 'string') {
            if (typeof value === 'number') {
                value = String(value);
            } else if (value && typeof value.trim === 'function') {
                value = value.trim();
            } else {
                value = String(value);
            }
        }
        return value.trim();
    }

    window.normalizeUnbxdSearchQuery = normalizeUnbxdSearchQuery;

    function getActiveHeaderSearchInput() {
        var mobile = document.getElementById('Search-In-Modal-mobile');
        var desktop = document.getElementById('Search-In-Modal');
        if (mobile && mobile.offsetParent !== null) return mobile;
        if (desktop && desktop.offsetParent !== null) return desktop;
        return mobile || desktop;
    }

    function getActiveHeaderSearchButton() {
        var input = getActiveHeaderSearchInput();
        if (!input || !input.id) return null;
        return document.getElementById(input.id + '-button');
    }

    window.getActiveHeaderSearchInput = getActiveHeaderSearchInput;
    window.syncHeaderSearchInputValues = syncHeaderSearchInputValues;

    function syncHeaderSearchInputValues(source) {
        if (!source) return;
        var mobile = document.getElementById('Search-In-Modal-mobile');
        var desktop = document.getElementById('Search-In-Modal');
        if (mobile && mobile !== source) mobile.value = source.value;
        if (desktop && desktop !== source) desktop.value = source.value;
    }

    function patchUnbxdActiveSearchInput(instance) {
        if (!instance || instance.__activeSearchInputPatched) return;
        instance.__activeSearchInputPatched = true;

        function refreshSearchBoxEl(preferred) {
            var input = preferred || getActiveHeaderSearchInput();
            if (input) {
                instance.options.searchBoxEl = input;
            }
            var btn = input && input.id ? document.getElementById(input.id + '-button') : null;
            if (btn) {
                instance.options.searchButtonEl = btn;
            }
            return input;
        }

        if (typeof instance.changeInput === 'function') {
            var originalChangeInput = instance.changeInput.bind(instance);
            instance.changeInput = function (value, eventName) {
                return originalChangeInput(normalizeUnbxdSearchQuery(value), eventName);
            };
        }

        if (typeof instance.trackSearch === 'function') {
            var originalTrackSearch = instance.trackSearch.bind(instance);
            instance.trackSearch = function (query) {
                var q = typeof query === 'string'
                    ? query
                    : (instance.state && instance.state.userInput);
                q = normalizeUnbxdSearchQuery(q);

                if (
                    window.shouldSuppressVanillaSearchTrackForAutosuggest
                    && window.shouldSuppressVanillaSearchTrackForAutosuggest(q)
                ) {
                    return;
                }

                return originalTrackSearch(q);
            };
        }

        if (typeof instance.getCallbackActions === 'function') {
            var originalGetCallbackActions = instance.getCallbackActions.bind(instance);
            instance.getCallbackActions = function (ctx, eventName) {
                if (eventName === 'CHANGE_INPUT') {
                    var query = normalizeUnbxdSearchQuery(
                        ctx && ctx.state ? ctx.state.userInput : ''
                    );
                    return originalGetCallbackActions(query, eventName);
                }
                return originalGetCallbackActions(ctx, eventName);
            };
        }

        var originalSetInputValue = instance.setInputValue.bind(instance);
        instance.setInputValue = function () {
            refreshSearchBoxEl();
            return originalSetInputValue();
        };

        var originalGetResults = instance.getResults.bind(instance);
        instance.getResults = function (query) {
            refreshSearchBoxEl();
            if (arguments.length > 0) {
                return originalGetResults(normalizeUnbxdSearchQuery(query));
            }
            return originalGetResults();
        };

        forEachHeaderSearchInput(function (input) {
            input.addEventListener('input', function () {
                clearUnbxdAutosuggestSubmitSuppress();
                syncHeaderSearchInputValues(input);
                refreshSearchBoxEl(input);
            });
        });

        refreshSearchBoxEl();
    }

    window.patchUnbxdActiveSearchInput = patchUnbxdActiveSearchInput;

    function patchAutosuggestActiveSearchInput(autosuggest) {
        if (!autosuggest || !autosuggest.domService || autosuggest.__activeInputPatched) return;
        autosuggest.__activeInputPatched = true;

        var dom = autosuggest.domService;

        if (!dom.__inputFocusPatched) {
            dom.__inputFocusPatched = true;
            var originalOnInputFocus = dom.onInputFocus.bind(dom);
            dom.onInputFocus = function (evt) {
                if (window.__unbxdSuppressAutosuggestPanel) return;
                var input = evt.target || dom.inputBox;
                if (!isAutosuggestQueryReady(input && input.value, autosuggest)) {
                    hideUnbxdAutosuggestPanel(autosuggest);
                    return;
                }
                originalOnInputFocus(evt);
            };
        }

        function bindAutosuggestInput(input) {
            if (!input || input.__unbxdAutosuggestBound) return;
            input.__unbxdAutosuggestBound = true;
            input.addEventListener('input', function (evt) {
                clearUnbxdAutosuggestSubmitSuppress();
                dom.onInputChange.call(dom, evt);
            });
            input.addEventListener('focus', dom.onInputFocus.bind(dom));
            input.addEventListener('blur', dom.onInputBlur.bind(dom));
            input.addEventListener('keydown', dom.onInputKeyDown.bind(dom));
        }

        function refreshAutosuggestInput(preferred) {
            var input = preferred || getActiveHeaderSearchInput();
            if (!input) return null;
            dom.inputBox = input;
            autosuggest.stateManager.updateState('dom__inputBox', input);
            bindAutosuggestInput(input);
            return input;
        }

        forEachHeaderSearchInput(function (input) {
            bindAutosuggestInput(input);
            input.addEventListener('input', function () {
                syncHeaderSearchInputValues(input);
                refreshAutosuggestInput(input);
            });
            input.addEventListener('focus', function () {
                refreshAutosuggestInput(input);
            });
        });

        refreshAutosuggestInput();
    }

    function getSearchInputQuery(input) {
        if (!input) return '';
        return normalizeUnbxdSearchQuery(input.value);
    }

    function getSearchPageUrlQuery() {
        try {
            var params = new URLSearchParams(window.location.search);
            var q = params.get('query') || params.get('q') || '';
            return decodeURIComponent(q).replace(/\+/g, ' ').trim();
        } catch (err) {
            return '';
        }
    }

    function mapUnbxdSearchProductToAutosuggest(product) {
        if (!product) return null;
        var imageUrl = product.imageUrl;
        if (Array.isArray(imageUrl)) imageUrl = imageUrl[0];
        var productUrl = product.productUrl;
        if (!productUrl && product.handle) productUrl = '/products/' + product.handle;
        return {
            doctype: 'POPULAR_PRODUCTS',
            title: product.title,
            uniqueId: product.uniqueId,
            imageUrl: imageUrl || '',
            productUrl: productUrl || '#',
            price: product.price,
            compareAtPrice: product.compareAtPrice,
            compare_at_price: product.compareAtPrice,
            v_compareAtPrice: product.v_compareAtPrice,
            availability: product.availability,
            variants: product.variants
        };
    }

    function hydrateAutosuggestFromSearchResults(autosuggest, query) {
        if (!autosuggest || !query || window.location.pathname.indexOf('/search') === -1) return false;

        var urlQuery = getSearchPageUrlQuery();
        if (!urlQuery || urlQuery.toLowerCase() !== query.toLowerCase()) return false;

        var searchProducts = window.unbxdSearch && window.unbxdSearch.state && window.unbxdSearch.state.products;
        if (!Array.isArray(searchProducts) || !searchProducts.length) return false;

        var popularConfig = autosuggest.configManager.getConfigs('apiConfigs.popularProducts') || {};
        var count = popularConfig.count != null ? popularConfig.count : 8;
        var popular = searchProducts.slice(0, count).map(mapUnbxdSearchProductToAutosuggest).filter(Boolean);

        if (!popular.length) return false;

        applyEnrichedPopularProducts(autosuggest, popular);
        updateAutosuggestDisplayCache(popular, query);
        autosuggest.stateManager.updateState('query', query);
        autosuggestRequestPending = false;
        return true;
    }

    async function ensureAutosuggestDataForQuery(autosuggest, query) {
        if (!autosuggest || window.__unbxdSuppressAutosuggestPanel) return;
        query = String(query || '').trim();

        if (query.length < getAutosuggestMinChars(autosuggest)) return;

        var state = autosuggest.stateManager.getState();
        var stateQuery = (state && state.query ? state.query : '').trim();
        var response = (state && state.response) || {};
        var popular = response.popularProducts || [];
        var hasSuggestions = popular.length > 0
            || (response.keywordSuggestions || []).length > 0
            || (response.inFields || []).length > 0
            || (response.topSearchQueries || []).length > 0;

        if (stateQuery === query && hasSuggestions) {
            try { autosuggest.renderSuggestions(); } catch (err) {}
            return;
        }

        if (autosuggestDisplayCache.query === query && autosuggestDisplayCache.popularProducts.length) {
            autosuggest.stateManager.updateState('query', query);
            try { autosuggest.renderSuggestions(); } catch (err) {}
        } else {
            hydrateAutosuggestFromSearchResults(autosuggest, query);
        }

        autosuggestRequestPending = true;
        autosuggest.stateManager.updateState('query', query);
        try {
            await autosuggest.setupAutosuggestion({ query: query });
        } catch (err) {}
    }

    window.unbxdEnsureAutosuggestForInput = function (query) {
        var api = window.unbxdHeaderAutosuggest;
        if (!api) return;
        if (!query) {
            var input = document.getElementById('Search-In-Modal');
            query = getSearchInputQuery(input);
        }
        return ensureAutosuggestDataForQuery(api, query);
    };

    function escapeHtml(text) {
        return String(text)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;');
    }

    function escapeAttr(text) {
        return String(text)
            .replace(/&/g, '&amp;')
            .replace(/"/g, '&quot;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;');
    }

    function decodeHtmlEntities(text) {
        if (typeof text !== 'string' || !text || text.indexOf('&') === -1) return text;
        var ta = document.createElement('textarea');
        ta.innerHTML = text;
        return ta.value;
    }

    window.unbxdDecodeSearchQuery = decodeHtmlEntities;

    window.unbxdNormalizeSearchInput = function (input) {
        if (!input) return;
        var decoded = decodeHtmlEntities(input.value);
        if (decoded !== input.value) input.value = decoded;
    };

    window.unbxdPatchUnbxdSearchInput = function (instance) {
        if (!instance || instance.__unbxdInputDecodePatched || typeof instance.reRender !== 'function') return;
        instance.__unbxdInputDecodePatched = true;
        var origReRender = instance.reRender.bind(instance);
        instance.reRender = function () {
            if (this.state && this.state.userInput) {
                this.state.userInput = decodeHtmlEntities(this.state.userInput);
            }
            origReRender();
            window.unbxdNormalizeSearchInput(getActiveHeaderSearchInput());
        };
    };

    function getSuggestionFilterData(item) {
        if (!item || typeof item !== 'object') return null;

        if (item.unbxdAutosuggestSrc) {
            const inKey = `${item.unbxdAutosuggestSrc}_in`;
            if (Array.isArray(item[inKey]) && item[inKey].length > 0) {
                return { name: item.unbxdAutosuggestSrc, value: String(item[inKey][0]) };
            }
        }

        for (const key of Object.keys(item)) {
            if (!key.endsWith('_in')) continue;
            const values = item[key];
            if (!Array.isArray(values) || !values.length) continue;
            return { name: key.slice(0, -3), value: String(values[0]) };
        }

        return null;
    }

    function renderSuggestionItemAttrs(item, typedQuery) {
        const autosuggest = item?.autosuggest || '';
        const filter = getSuggestionFilterData(item);
        const dataValue = filter ? `${autosuggest}:${filter.value}` : autosuggest;
        let attrs = `data-value="${escapeAttr(dataValue)}"`;

        if (typedQuery) {
            attrs += ` data-typed-query="${escapeAttr(typedQuery)}"`;
        }

        if (filter) {
            attrs += ` data-filtername="${escapeAttr(filter.name)}" data-filtervalue="${escapeAttr(filter.value)}"`;
        }

        return attrs;
    }

    function getSuggestionTypedQuery(suggestion) {
        var input = getActiveHeaderSearchInput();
        var fromInput = getSearchInputQuery(input);
        if (fromInput) return fromInput;

        if (suggestion && suggestion.dataset.typedQuery) {
            return normalizeUnbxdSearchQuery(decodeHtmlEntities(suggestion.dataset.typedQuery));
        }

        return '';
    }

    function buildAutosuggestSearchPayload(suggestion, parsed, typedQuery) {
        var doctype = suggestion.dataset.doctype || '';
        var rank = suggestion.dataset.index;
        var payload = {
            autosuggest_type: doctype,
            autosuggest_suggestion: parsed.searchQuery,
            internal_query: typedQuery
        };

        if (rank != null && rank !== '') {
            var prank = parseInt(rank, 10);
            if (!isNaN(prank)) payload.unbxdprank = prank;
        }

        if (parsed.filterName) {
            payload.field_name = parsed.filterName;
            payload.field_value = parsed.filterValue;
        }

        return payload;
    }

    function markUnbxdAutosuggestSuggestionClick(typedQuery, searchQuery, doctype) {
        var signature = [
            String(typedQuery || '').toLowerCase(),
            String(searchQuery || '').toLowerCase()
        ].join('|');
        window.__unbxdAutosuggestClickSignature = signature;

        try {
            sessionStorage.removeItem('unbxdAutosuggestSearchFired');
            sessionStorage.setItem('unbxdAutosuggestClickSignature', signature);
            sessionStorage.setItem('unbxdAutosuggestSuggestionQuery', String(searchQuery || ''));
            sessionStorage.setItem('unbxdAutosuggestInternalQuery', String(typedQuery || ''));
            sessionStorage.setItem('unbxdAutosuggestDoctype', String(doctype || 'KEYWORD_SUGGESTION'));
            sessionStorage.setItem('unbxdAutosuggestClickAt', String(Date.now()));
        } catch (err) {}
    }

    function sendUnbxdAutosuggestSearchAnalytics(parsed, typedQuery, doctype) {
        if (!parsed) return false;

        try {
            if (sessionStorage.getItem('unbxdAutosuggestSearchFired') === '1') {
                return true;
            }
        } catch (err) {}

        var clickSignature = [
            String(typedQuery || '').toLowerCase(),
            String(parsed.searchQuery || '').toLowerCase(),
            String(doctype || '')
        ].join('|');

        if (window.__unbxdLastAutosuggestSearchSignature === clickSignature) {
            return true;
        }

        var autosuggestData = {
            autosuggest_type: doctype,
            autosuggest_suggestion: parsed.searchQuery,
            internal_query: typedQuery
        };

        if (parsed.filterName) {
            autosuggestData.field_name = parsed.filterName;
            autosuggestData.field_value = parsed.filterValue;
        }

        if (!(window.Unbxd && typeof window.Unbxd.addSearch === 'function')) {
            return false;
        }

        window.Unbxd.addSearch(parsed.searchQuery, autosuggestData);
        window.__unbxdLastAutosuggestSearchSignature = clickSignature;

        try {
            sessionStorage.setItem('unbxdAutosuggestSearchFired', '1');
        } catch (err) {}

        return true;
    }

    function fireUnbxdAutosuggestSuggestionSearch(suggestion) {
        var parsed = parseSuggestionSearchQuery(suggestion);
        if (!parsed) return false;

        var typedQuery = getSuggestionTypedQuery(suggestion);
        var doctype = suggestion.dataset.doctype || 'KEYWORD_SUGGESTION';

        markUnbxdAutosuggestSuggestionClick(typedQuery, parsed.searchQuery, doctype);

        if (!canRunInPlaceUnbxdSearch()) {
            return true;
        }

        if (sendUnbxdAutosuggestSearchAnalytics(parsed, typedQuery, doctype)) {
            return true;
        }

        if (window.whenUnbxdTrackReady) {
            window.whenUnbxdTrackReady(function () {
                sendUnbxdAutosuggestSearchAnalytics(parsed, typedQuery, doctype);
            });
        }

        return true;
    }

    window.fireUnbxdAutosuggestSuggestionSearch = fireUnbxdAutosuggestSuggestionSearch;

    function getUnbxdThemeConfig() {
        return window.UnbxdThemeConfig || {};
    }

    function buildSuggestionSearchUrl(searchQuery, filterName, filterValue) {
        const url = new URL(getUnbxdThemeConfig().searchUrl || '/search', window.location.origin);
        // url.searchParams.set('query', searchQuery);
        url.searchParams.set('q', searchQuery);

        if (filterName && filterValue) {
            if (filterName === 'categoryPath') {
                url.searchParams.set('category-filter', filterValue);
            } else {
                url.searchParams.set('filter', `${filterName}:"${filterValue}"`);
            }
        }

        return url.pathname + url.search;
    }

    function isUnbxdSearchResultsPage() {
        var path = window.location.pathname.replace(/\/$/, '') || '/';
        return path === '/search' || path.indexOf('/search/') === 0;
    }

    function canRunInPlaceUnbxdSearch() {
        return isUnbxdSearchResultsPage()
            && window.unbxdSearch
            && typeof window.unbxdSearch.setInputValue === 'function';
    }

    function prepareUnbxdSearchInputForSubmit(input) {
        if (!input || !window.unbxdSearch) return;
        window.unbxdSearch.options.searchBoxEl = input;
        var btn = input.id ? document.getElementById(input.id + '-button') : null;
        if (btn) {
            window.unbxdSearch.options.searchButtonEl = btn;
        }
    }

    var lastHeaderSearchSubmitAt = 0;

    function submitHeaderSearchFromInput(input, event) {
        if (!input) return false;

        var query = getSearchInputQuery(input);
        if (!query) {
            if (event) {
                event.preventDefault();
                event.stopPropagation();
            }
            return false;
        }

        var now = Date.now();
        if (now - lastHeaderSearchSubmitAt < 400) {
            if (event) {
                event.preventDefault();
                event.stopPropagation();
            }
            return true;
        }
        lastHeaderSearchSubmitAt = now;

        syncHeaderSearchInputValues(input);

        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        closeUnbxdHeaderAutosuggestForSubmit({ skipBlur: true });

        if (canRunInPlaceUnbxdSearch()) {
            prepareUnbxdSearchInputForSubmit(input);
            window.unbxdSearch.setInputValue();
            if (document.activeElement === input) input.blur();
            return true;
        }

        window.location.href = buildSuggestionSearchUrl(query);
        return true;
    }

    window.submitHeaderSearchFromInput = submitHeaderSearchFromInput;

    var suggestionSearchTimer = null;
    var suggestionSearchPending = false;

    function parseSuggestionSearchQuery(suggestion) {
        if (!suggestion) return null;

        const doctype = suggestion.dataset.doctype;
        if (!SUGGESTION_SEARCH_DOCTYPES.includes(doctype)) {
            return null;
        }

        let searchQuery = suggestion.dataset.value || suggestion.textContent.trim();
        const filterName = suggestion.dataset.filtername || '';
        const filterValue = suggestion.dataset.filtervalue || '';

        if (searchQuery.includes(':')) {
            searchQuery = searchQuery.split(':')[0];
        }

        searchQuery = decodeHtmlEntities(String(searchQuery || '').trim());
        if (!searchQuery) return null;

        return {
            searchQuery: searchQuery,
            filterName: filterName,
            filterValue: filterValue
        };
    }

    function runInPlaceUnbxdSuggestionSearch(searchQuery, input) {
        var instance = window.unbxdSearch;
        if (!instance || typeof instance.changeInput !== 'function' || typeof instance.getResults !== 'function') {
            return false;
        }

        prepareUnbxdSearchInputForSubmit(input);

        if (typeof instance.resetAll === 'function') instance.resetAll();
        instance.changeInput(searchQuery, instance.events && instance.events.changeInput);
        instance.options.productType = 'SEARCH';
        if (instance.options.products) instance.options.products.productType = 'SEARCH';
        if (instance.viewState) instance.viewState.loadedFromSuggestion = false;
        if (instance.state) instance.state.selectedSort = '';
        if (typeof instance.setPageStart === 'function') instance.setPageStart(0);
        if (typeof instance.resetViewState === 'function') instance.resetViewState();
        instance.getResults();

        if (input) {
            input.value = searchQuery;
            syncHeaderSearchInputValues(input);
        }

        return true;
    }

    function applySuggestionSearch(searchQuery, filterName, filterValue) {
        var input = getActiveHeaderSearchInput();

        closeUnbxdHeaderAutosuggestForSubmit({ skipBlur: true });

        if (canRunInPlaceUnbxdSearch()) {
            if (!runInPlaceUnbxdSuggestionSearch(searchQuery, input) && typeof window.unbxdSearch.setInputValue === 'function') {
                if (input) {
                    input.value = searchQuery;
                    syncHeaderSearchInputValues(input);
                }
                prepareUnbxdSearchInputForSubmit(input);
                window.unbxdSearch.setInputValue();
            }
            return;
        }

        window.location.href = buildSuggestionSearchUrl(searchQuery, filterName, filterValue);
    }

    function navigateToSuggestion(suggestion) {
        var parsed = parseSuggestionSearchQuery(suggestion);
        if (!parsed) return false;

        if (suggestionSearchPending) return true;

        suggestionSearchPending = true;
        if (suggestionSearchTimer) {
            clearTimeout(suggestionSearchTimer);
            suggestionSearchTimer = null;
        }

        document.querySelectorAll('.unbxd-as-keysuggestion.unbxd-as-keysuggestion--pending').forEach(function (el) {
            el.classList.remove('unbxd-as-keysuggestion--pending');
        });
        suggestion.classList.add('unbxd-as-keysuggestion--pending');

        suggestionSearchTimer = setTimeout(function () {
            suggestionSearchTimer = null;
            suggestionSearchPending = false;
            suggestion.classList.remove('unbxd-as-keysuggestion--pending');
            applySuggestionSearch(parsed.searchQuery, parsed.filterName, parsed.filterValue);
        }, SUGGESTION_SEARCH_DELAY_MS);

        return true;
    }

    function parseAutosuggestByDoctype(products) {
        var out = {
            POPULAR_PRODUCTS: [],
            IN_FIELD: [],
            KEYWORD_SUGGESTION: [],
            PROMOTED_SUGGESTION: [],
            TOP_SEARCH_QUERIES: []
        };
        if (!Array.isArray(products)) return out;
        products.forEach(function (item) {
            var type = item && item.doctype;
            if (!type) return;
            if (!out[type]) out[type] = [];
            out[type].push(item);
        });
        return out;
    }

    function clearAutosuggestResponseData(autosuggest) {
        autosuggest.stateManager.updateState('response__products', []);
        autosuggest.stateManager.updateState('response__popularProducts', []);
        autosuggest.stateManager.updateState('response__inFields', []);
        autosuggest.stateManager.updateState('response__keywordSuggestions', []);
        autosuggest.stateManager.updateState('response__promotedSuggestions', []);
        autosuggest.stateManager.updateState('response__topSearchQueries', []);
    }

    function syncAutosuggestResponseFromApi(autosuggest) {
        var state = autosuggest.stateManager.getState();
        var products = state && state.response && state.response.products;
        if (!Array.isArray(products) || products.length === 0) {
            clearAutosuggestResponseData(autosuggest);
            return;
        }
        var parsed = parseAutosuggestByDoctype(products);
        autosuggest.stateManager.updateState(
            'response__popularProducts',
            asPopularProductsList(parsed.POPULAR_PRODUCTS || [])
        );
        autosuggest.stateManager.updateState('response__inFields', parsed.IN_FIELD || []);
        autosuggest.stateManager.updateState('response__keywordSuggestions', parsed.KEYWORD_SUGGESTION || []);
        autosuggest.stateManager.updateState('response__promotedSuggestions', parsed.PROMOTED_SUGGESTION || []);
        autosuggest.stateManager.updateState('response__topSearchQueries', parsed.TOP_SEARCH_QUERIES || []);
    }

    function getSearchProductComparePrice(product) {
        if (!product) return NaN;
        var raw = product.compareAtPrice
            ?? product.compare_at_price
            ?? product.v_compareAtPrice
            ?? product.unxCompareAtPrice;
        var amount = parseFloat(raw);
        return isNaN(amount) ? NaN : amount;
    }

    function mergeVariantCompareFromSearch(asVariants, searchVariants) {
        var asList = Array.isArray(asVariants) ? asVariants : [];
        var searchList = Array.isArray(searchVariants) ? searchVariants : [];
        if (!asList.length || !searchList.length) return asVariants;

        return asList.map(function (variant) {
            var variantId = variant.vId || variant.variantId || variant.id;
            var match = searchList.find(function (searchVariant) {
                return (searchVariant.vId || searchVariant.variantId || searchVariant.id) === variantId;
            });
            if (!match) return variant;

            var comparePrice = getSearchProductComparePrice(match);
            if (isNaN(comparePrice)) return variant;

            return Object.assign({}, variant, {
                compareAtPrice: comparePrice,
                compare_at_price: comparePrice,
                v_compareAtPrice: comparePrice
            });
        });
    }

    function mergePopularProductCompareFromSearch(popularProduct, searchProduct) {
        if (!popularProduct || !searchProduct) return popularProduct;

        var comparePrice = getSearchProductComparePrice(searchProduct);
        var merged = Object.assign({}, popularProduct);

        if (!isNaN(comparePrice)) {
            merged.compareAtPrice = comparePrice;
            merged.compare_at_price = comparePrice;
            if (merged.v_compareAtPrice == null || isNaN(parseFloat(merged.v_compareAtPrice))) {
                merged.v_compareAtPrice = comparePrice;
            }
        }

        if (popularProduct.variants || searchProduct.variants) {
            merged.variants = mergeVariantCompareFromSearch(
                popularProduct.variants,
                searchProduct.variants
            );
        }

        return merged;
    }

    function applyEnrichedPopularProducts(autosuggest, enrichedPopular) {
        var popularList = asPopularProductsList(enrichedPopular);
        autosuggest.stateManager.updateState('response__popularProducts', popularList);

        var state = autosuggest.stateManager.getState();
        var products = state && state.response && state.response.products;
        if (!Array.isArray(products)) return;

        var byId = {};
        popularList.forEach(function (product) {
            if (product && product.uniqueId) byId[product.uniqueId] = product;
        });

        autosuggest.stateManager.updateState('response__products', products.map(function (item) {
            if (!item || item.doctype !== 'POPULAR_PRODUCTS') return item;
            if (!item.uniqueId || !byId[item.uniqueId]) return null;
            return byId[item.uniqueId];
        }).filter(Boolean));
    }

    var autosuggestPriceEnrichSeq = 0;

    async function enrichPopularProductsComparePrices(autosuggest, query) {
        if (!autosuggest || !autosuggest.apiService || !query) return false;

        var state = autosuggest.stateManager.getState();
        var popularProducts = state && state.response && state.response.popularProducts;
        if (!Array.isArray(popularProducts) || !popularProducts.length) return false;

        var seq = ++autosuggestPriceEnrichSeq;

        try {
            var searchResponse = await autosuggest.apiService.request('SEARCH', { query: query });
            if (seq !== autosuggestPriceEnrichSeq) return false;

            var latestState = autosuggest.stateManager.getState();
            if ((latestState && latestState.query ? latestState.query : '').trim() !== query.trim()) {
                return false;
            }

            var searchProducts = searchResponse && searchResponse.response && searchResponse.response.products;
            if (!Array.isArray(searchProducts) || !searchProducts.length) return false;

            var searchById = {};
            searchProducts.forEach(function (product) {
                if (product && product.uniqueId) searchById[product.uniqueId] = product;
            });

            var enriched = popularProducts.map(function (product) {
                var searchMatch = searchById[product.uniqueId];
                return searchMatch
                    ? mergePopularProductCompareFromSearch(product, searchMatch)
                    : product;
            });

            applyEnrichedPopularProducts(autosuggest, enriched);
            return true;
        } catch (err) {
            return false;
        }
    }

    function getAutosuggestMountTarget() {
        var mobileHost = document.querySelector('.header__search.mobile-search');
        var desktopHost = document.querySelector('.header__search.desktop-search');
        if (mobileHost && mobileHost.offsetParent !== null) return mobileHost;
        return desktopHost || document.querySelector('.header__search');
    }

    function ensureUnbxdAutosuggestPlacement(autosuggest) {
        var target = getAutosuggestMountTarget();
        if (!target) return;

        var box = (autosuggest && autosuggest.domService && autosuggest.domService.autosuggestionBox)
            || document.querySelector('.unbxd-autosuggest-result');
        if (!box || box.parentNode === target) return;

        target.appendChild(box);
    }

    function patchAutosuggestDomPlacement(autosuggest) {
        if (!autosuggest || autosuggest.__domPlacementPatched) return;
        autosuggest.__domPlacementPatched = true;

        var dom = autosuggest.domService;
        if (!dom) return;

        var originalUpdate = dom.updateSuggestionBoxHTML.bind(dom);
        dom.updateSuggestionBoxHTML = function (html) {
            originalUpdate(html);
            finishAutosuggestPanelUpdate(autosuggest);
        };

        dom.mountAutosuggestionBox = function () {
            try {
                var html = this.autosuggestionBox && this.autosuggestionBox.innerHTML
                    ? this.autosuggestionBox.innerHTML.trim()
                    : '';
                if (!html) {
                    this.unmountAutosuggestionBox();
                    return;
                }
                ensureUnbxdAutosuggestPlacement(autosuggest);
                this.autosuggestionBox.classList.remove('unbxd-as-panel-hidden');
            } catch (err) {
                console.error('mountAutosuggestionBox', err);
            }
        };

        var originalUpdatePopularProducts = dom.updatePopularProductsSection.bind(dom);
        dom.updatePopularProductsSection = function (productHtml) {
            var box = this.autosuggestionBox;
            var productsList = box && box.querySelector('.unx-popular-products');
            var noResultsWrapper = box && box.querySelector('.unbxd-as-no-results-only');

            if (!productsList || noResultsWrapper) {
                try {
                    autosuggest.renderSuggestions();
                } catch (err) {
                    console.error('updatePopularProductsSection fallback', err);
                }
                refreshUnbxdAutosuggestReviews();
                return;
            }

            originalUpdatePopularProducts(productHtml);
            refreshUnbxdAutosuggestReviews();
        };
    }

    function patchAutosuggestSuggestionHover(autosuggest) {
        if (!autosuggest || autosuggest.__suggestionHoverPatched) return;
        autosuggest.__suggestionHoverPatched = true;

        var dom = autosuggest.domService;
        if (!dom || !dom.autosuggestionBox || !dom.onAutosuggestionBoxHover) return;

        var hoverHandler = dom.onAutosuggestionBoxHover.bind(dom);

        dom.autosuggestionBox.addEventListener('mouseover', function (event) {
            var target = event.target;
            if (!target || !target.closest) return;
            if (target.classList && target.classList.contains('unx-item')) return;

            var item = target.closest('.unx-item[data-doctype]');
            if (!item || !SUGGESTION_HOVER_DOCTYPES.includes(item.dataset.doctype)) return;

            hoverHandler({ target: item });
        });
    }

    function patchAutosuggestQuerySync(autosuggest) {
        if (autosuggest.__querySyncPatched) return;
        autosuggest.__querySyncPatched = true;

        var originalRenderSuggestions = autosuggest.renderSuggestions.bind(autosuggest);

        autosuggest.renderSuggestions = function () {
            if (window.__unbxdSuppressAutosuggestPanel) {
                hideUnbxdAutosuggestPanel(autosuggest);
                return;
            }

            var state = autosuggest.stateManager.getState();
            var query = (state && state.query ? state.query : '').trim();
            var minChars = getAutosuggestMinChars(autosuggest);

            if (!isAutosuggestQueryReady(query, autosuggest)) {
                hideUnbxdAutosuggestPanel(autosuggest);
                return;
            }
            var products = (state && state.response && state.response.products) || [];
            var popular = (state && state.response && state.response.popularProducts) || [];
            var displayPopular = getDisplayPopularProducts(popular);
            var trending = (state && state.response && state.response.trendingSearches) || [];
            var initial = (state && state.response && state.response.initialRequestProducts) || [];
            var template = autosuggest.configManager.getConfigs('suggestionBoxConfigs.template');
            var hasStaleProducts = autosuggestRequestPending && displayPopular.length > 0;

            if (
                query.length >= minChars
                && products.length === 0
                && !hasStaleProducts
                && !autosuggestRequestPending
                && trending.length === 0
                && initial.length === 0
                && typeof template === 'function'
            ) {
                mountAutosuggestTemplate(autosuggest, template, state);
                return;
            }

            if (hasStaleProducts && typeof template === 'function') {
                mountAutosuggestTemplate(autosuggest, template, Object.assign({}, state, {
                    response: Object.assign({}, state.response, {
                        popularProducts: displayPopular
                    })
                }));
                return;
            }

            originalRenderSuggestions();
            finishAutosuggestPanelUpdate(autosuggest);
        };
    }

    function highlightAutosuggestMatch(text, query) {
        if (!query) return text;
        var escapedQuery = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        return text.replace(new RegExp('(' + escapedQuery + ')', 'ig'), '<span class="unbxd-ac-selected">$1</span>');
    }

    function getAutosuggestCurrencySymbol(currencyCode) {
        try {
            var parts = new Intl.NumberFormat(undefined, {
                style: 'currency',
                currency: currencyCode,
                currencyDisplay: 'narrowSymbol'
            }).formatToParts(0);
            var symbolPart = parts.find(function (p) { return p.type === 'currency'; });
            return symbolPart ? symbolPart.value : currencyCode;
        } catch (err) {
            return currencyCode;
        }
    }

    function parseUnbxdAmount(value) {
        if (value === null || value === undefined || value === '') return NaN;
        if (Array.isArray(value)) return parseUnbxdAmount(value[0]);
        var amount = parseFloat(value);
        return isNaN(amount) ? NaN : amount;
    }

    function formatAutosuggestPrice(price) {
        var amount = parseUnbxdAmount(price);
        if (isNaN(amount)) return '';
        var activeCurrency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
        return getAutosuggestCurrencySymbol(activeCurrency) + amount.toFixed(2);
    }

    function normalizeAutosuggestVariants(product) {
        if (!product) return [];
        var variants = product.variants;
        if (typeof variants === 'string') {
            try { variants = JSON.parse(variants); } catch (err) { variants = []; }
        }
        return Array.isArray(variants) ? variants : [];
    }

    function isVariantAvailableForSale(variant) {
        if (!variant) return false;
        var available = variant.v_availableForSale ?? variant.availableForSale ?? variant.available;
        return available === true || available === 'true' || available === 1 || available === '1';
    }

    function getPreferredAutosuggestVariant(product) {
        var variants = normalizeAutosuggestVariants(product);
        if (!variants.length) return null;
        var available = variants.find(function (v) {
            return isVariantAvailableForSale(v) && (v.variantId || v.id);
        });
        if (available) return available;
        return variants.find(function (v) { return v.variantId || v.id; }) || variants[0];
    }

    function getAutosuggestProductPrices(product) {
        var variant = getPreferredAutosuggestVariant(product);
        var price = parseUnbxdAmount(product.price);
        var comparePrice = parseUnbxdAmount(
            product.compare_at_price
            ?? product.compareAtPrice
            ?? product.compare_at
            ?? product.unxCompareAtPrice
            ?? product.v_compareAtPrice
        );

        if (variant) {
            var variantPrice = parseUnbxdAmount(variant.v_price ?? variant.price);
            var variantCompare = parseUnbxdAmount(
                variant.v_compareAtPrice ?? variant.compareAtPrice ?? variant.compare_at_price
            );
            if (!isNaN(variantPrice)) price = variantPrice;
            if (!isNaN(variantCompare)) comparePrice = variantCompare;
        }

        return {
            price: price,
            comparePrice: comparePrice,
            isOnSale: !isNaN(price) && !isNaN(comparePrice) && comparePrice > price
        };
    }

    function renderAutosuggestPriceHtml(product) {
        var prices = getAutosuggestProductPrices(product);
        if (prices.isOnSale) {
            return '<div class="unbxd-as-price-sale price--on-sale">'
                + '<span class="price-item price-item--sale price-item--last">' + formatAutosuggestPrice(prices.price) + '</span>'
                + '<span><s class="price-item price-item--regular">' + formatAutosuggestPrice(prices.comparePrice) + '</s></span>'
                + '</div>';
        }
        return '<span class="price-item price-item--regular">' + formatAutosuggestPrice(prices.price) + '</span>';
    }

    function renderAutosuggestPopularProduct(product, index) {
        var productId = product.uniqueId || product.id || '';
        var productValue = product.title || product.autosuggest || product.productUrl || productId;
        var isOos = isUnbxdAutosuggestProductOutOfStock(product);
        var $saleLabel = "";
        if(product.productType == "Stacks"){
            $saleLabel = `<span class="custom-sale-label">$${(product.price * 0.9).toFixed(2)} at checkout</span>`;
        } else if(product.vendor == "Emrald Labs" || product.vendor == "Lunar Performance" || product.vendor == "Elite Supplements"){
            $saleLabel = `<span class="custom-sale-label">$${(product.price * 0.7).toFixed(2)} at checkout</span>`;
        } else{
            $saleLabel = `<span class="custom-sale-label">$${(product.price * 0.9).toFixed(2)} at checkout</span>`;
        }
        return '<li class="unbxd-as-popular-product' + (isOos ? ' unbxd-as-popular-product--oos' : '') + '"'
            + ' data-doctype="POPULAR_PRODUCTS"'
            + ' data-value="' + escapeAttr(productValue) + '"'
            + ' data-index="' + index + '"'
            + ' data-id="' + escapeAttr(productId) + '">'
            + $saleLabel
            + '<a href="' + (product.productUrl || '#') + '" class="unbxd-as-popular-product-link">'
            + '<div class="unbxd-as-popular-product-info">'
            + '<div class="unbxd-as-popular-product-image-container">'
            // + (isOos ? '<span class="unbxd-as-stock-badge">Out of stock</span>' : '')
            + '<img src="' + (product.imageUrl || '') + '&width=400" alt="' + escapeAttr(product.title || '') + '">'
            + '</div>'
            + '<div class="UNX-product-info">'
            + '<div class="UNX-product-title"><h3>' + escapeHtml(product.title || '') + '</h3></div>'
            + '<div class="unbxd-product-review">'
            + '<div class="klaviyo-star-rating-widget" data-id="' + escapeAttr(product.uniqueId) + '" data-product-title="' + escapeAttr(product.title || '') + '"></div>'
            + '</div>'
            + '<div class="unbxd-as-popular-product-price">' + renderAutosuggestPriceHtml(product) + '</div>'
            + '</div></div></a></li>';
    }

    function renderAutosuggestSuggestionList(items, query, doctype, renderAttrs) {
        if (!items || !items.length) return '';
        return items.map(function (item, i) {
            return '<li class="unbxd-as-keysuggestion unx-item"'
                + (renderAttrs ? ' ' + renderAttrs(item, query) : ' data-value="' + escapeAttr(item.autosuggest) + '"')
                + ' data-index="' + i + '"'
                + ' data-doctype="' + doctype + '">'
                + '<span class="unbxd-as-keysuggestion-icon" aria-hidden="true"></span>'
                + '<span class="unbxd-as-keysuggestion-label">' + highlightAutosuggestMatch(item.autosuggest, query) + '</span>'
                + '</li>';
        }).join('');
    }

    function renderAutosuggestTemplate(state) {
        var query = (state && state.query) || '';
        var response = (state && state.response) || {};
        var keywordSuggestions = response.keywordSuggestions || [];
        var popularProducts = response.popularProducts || [];
        var trendingSearches = response.trendingSearches || [];
        var inFields = response.inFields || [];

        if (!query.trim() && trendingSearches.length > 0) {
            return '<div class="unbxd-as-wrapper">'
                + '<div class="unbxd-as-header"><h3>Trending Searches</h3></div>'
                + '<ul class="unbxd-as-maincontent-ul">'
                + renderAutosuggestSuggestionList(trendingSearches, query, 'trending', null)
                + '</ul></div>';
        }

        var displayPopularProducts = getDisplayPopularProducts(popularProducts);
        var hasPopularProducts = displayPopularProducts.length > 0;
        var showNoResults = !hasPopularProducts && !autosuggestRequestPending;
        var hasTextSuggestions = keywordSuggestions.length > 0 || inFields.length > 0;
        var wrapperClass = 'unbxd-as-wrapper unbxd-as-overall-autosuggest'
            + (showNoResults ? ' unbxd-as-no-results-only' : '')
            + (!showNoResults && !hasTextSuggestions ? ' unbxd-as-products-only' : '');

        var html = '<div class="' + wrapperClass + '">';

        if (hasTextSuggestions) {
            html += '<div class="unbxd-as-maincontent">';
            if (keywordSuggestions.length > 0) {
                html += '<div class="unbxd-as-header-suggestions">'
                    + '<div class="unbxd-as-header"><h3>Keyword Suggestions</h3></div>'
                    + '<ul class="unbxd-as-maincontent-ul">'
                    + renderAutosuggestSuggestionList(keywordSuggestions, query, 'KEYWORD_SUGGESTION', renderSuggestionItemAttrs)
                    + '</ul></div>';
            }
            if (inFields.length > 0) {
                html += '<div class="unbxd-as-header-queries">'
                    + '<div class="unbxd-as-header"><h3>Top Queries</h3></div>'
                    + '<ul class="unbxd-as-maincontent-ul">'
                    + renderAutosuggestSuggestionList(inFields, query, 'INFIELD_SUGGESTION', renderSuggestionItemAttrs)
                    + '</ul></div>';
            }
            html += '</div>';
        }

        html += '<div class="unbxd-as-sidecontent">';
        if (hasPopularProducts) {
            html += '<div class="unbxd-as-header unbxd-as-popular-product-header"><h3>Popular Products</h3></div>'
                + '<ul class="unbxd-as-sidecontent-products unx-popular-products'
                + (autosuggestRequestPending ? ' unbxd-as-products-pending' : '') + '">'
                + displayPopularProducts.map(renderAutosuggestPopularProduct).join('')
                + '</ul>'
                + '<button type="button" class="unbxd-as-view-button">See all products</button>';
        } else {
            html += '<div class="unbxd-as-no-results">'
                + '<p class="unbxd-as-no-results-message">Sorry, no result found for "<strong>'
                + escapeHtml(query) + '</strong>"</p></div>';
        }
        html += '</div></div>';
        return html;
    }

    function createAutosuggestEventHandler(getApi) {
        return function (payload) {
            var api = getApi();
            if (!api) return;

            var eventType = payload && payload.eventType;
            var minChars = getAutosuggestMinChars(api);

            if (eventType === 'AUTOSUGGEST_QUERY_UPDATED') {
                var q = normalizeUnbxdSearchQuery(payload.query || '');
                if (q.length >= minChars) {
                    autosuggestRequestPending = true;
                } else {
                    autosuggestRequestPending = false;
                    updateAutosuggestDisplayCache([], '');
                    clearAutosuggestResponseData(api);
                }
                return;
            }

            if (eventType === 'BEFORE_AUTOSUGGEST_API_CALL') {
                autosuggestRequestPending = true;
                return;
            }

            if (eventType === 'AFTER_AUTOSUGGEST_API_CALL') {
                var requestQuery = normalizeUnbxdSearchQuery(payload.query || '');
                setTimeout(async function () {
                    var state = api.stateManager.getState();
                    if (normalizeUnbxdSearchQuery(state && state.query ? state.query : '') !== requestQuery) return;
                    syncAutosuggestResponseFromApi(api);

                    state = api.stateManager.getState();
                    var latestPopular = (state && state.response && state.response.popularProducts) || [];
                    updateAutosuggestDisplayCache(latestPopular, requestQuery);
                    autosuggestRequestPending = false;

                    try { api.renderSuggestions(); } catch (err) {}

                    var searchCfg = api.configManager.getConfigs('apiConfigs.search') || {};
                    if (searchCfg.enrichComparePrice !== false) {
                        var enriched = await enrichPopularProductsComparePrices(api, requestQuery);
                        if (enriched) {
                            try { api.renderSuggestions(); } catch (renderErr) {}
                        }
                    }
                }, 0);
            }
        };
    }

    function initHeaderAutosuggest() {
        if (!window.AutosuggestSDK || !window.AutosuggestSDK.Autosuggest) {
            console.error('AutosuggestSDK not loaded');
            return;
        }

        var headerAutosuggest;
        headerAutosuggest = new AutosuggestSDK.Autosuggest({
            siteKey: getUnbxdThemeConfig().siteKey || '',
            apiKey: getUnbxdThemeConfig().apiKey || '',
            inputBoxConfigs: {
                searchInput: '#Search-In-Modal',
                debounceDelay: 100,
                minChars: 2
            },
            suggestionBoxConfigs: {
                containerTag: 'div',
                attributes: { class: 'unbxd-autosuggest-result' },
                template: renderAutosuggestTemplate
            },
            apiConfigs: {
                apiEndpoint: 'https://search.unbxd.io',
                initialRequest: false,
                inFields: { count: 5 },
                popularProducts: {
                    count: 8,
                    fields: ['availability', 'title', 'uniqueId', 'imageUrl', 'productType','vendor','productUrl', 'price', 'compare_at_price', 'compareAtPrice', 'v_compareAtPrice', 'variants', 'variantId', 'v_price', 'v_availableForSale', 'id', 'doctype']
                },
                keywordSuggestions: { count: 5 },
                topQueries: { count: 5 },
                promotedSuggestions: { count: 5 },
                trendingSearches: { count: 5 },
                search: {
                    prefetch: false,
                    filterField: '',
                    enrichComparePrice: true,
                    fields: ['uniqueId', 'price', 'compareAtPrice', 'compare_at_price', 'v_compareAtPrice', 'variants']
                }
            },
            onEvent: createAutosuggestEventHandler(function () { return headerAutosuggest; })
        });

        window.unbxdHeaderAutosuggest = headerAutosuggest;
        patchAutosuggestActiveSearchInput(headerAutosuggest);
        patchAutosuggestDomPlacement(headerAutosuggest);
        patchAutosuggestQuerySync(headerAutosuggest);
        patchAutosuggestSuggestionHover(headerAutosuggest);
        ensureUnbxdAutosuggestPlacement(headerAutosuggest);
        bindUnbxdAutosuggestOpenClose();

        var themeConfig = getUnbxdThemeConfig();
        if (themeConfig.moneyFormat) {
            window.theme = window.theme || {};
            window.theme.moneyFormat = themeConfig.moneyFormat;
        }
    }

    function bindUnbxdAutosuggestOpenClose() {
        function getPanel() {
            return document.querySelector('.unbxd-autosuggest-result');
        }

        function getSearchInput() {
            return getActiveHeaderSearchInput();
        }

        function isHeaderSearchField(target) {
            if (!target) return false;
            var mobile = document.getElementById('Search-In-Modal-mobile');
            var desktop = document.getElementById('Search-In-Modal');
            return target === mobile || target === desktop
                || (mobile && mobile.contains(target))
                || (desktop && desktop.contains(target));
        }

        function isHeaderSearchSubmitButton(target) {
            if (!target) return false;
            return !!target.closest(
                'button.search__button, #Search-In-Modal-button, #Search-In-Modal-mobile-button'
            );
        }

        function isHeaderSearchInput(target) {
            if (!target || target.tagName !== 'INPUT') return false;
            return HEADER_SEARCH_INPUT_IDS.indexOf(target.id) !== -1;
        }

        function hideAutosuggestPanel() {
            var box = getPanel();
            if (box) box.classList.add('unbxd-as-panel-hidden');
        }

        function closeAutosuggestForSearchAction() {
            closeUnbxdHeaderAutosuggestForSubmit();
        }

        function reopenAutosuggestPanel() {
            if (window.__unbxdSuppressAutosuggestPanel) return;

            var inp = getSearchInput();
            var box = getPanel();
            var api = window.unbxdHeaderAutosuggest;
            if (!inp || !box || !api) return;

            var query = getSearchInputQuery(inp);
            if (!isAutosuggestQueryReady(query, api)) {
                hideAutosuggestPanel();
                return;
            }

            box.classList.remove('unbxd-as-panel-hidden');
            ensureAutosuggestDataForQuery(api, query);
        }

        document.addEventListener(
            'mousedown',
            function (e) {
                var inp = getSearchInput();
                var box = getPanel();
                if (!inp || !box) return;
                if (box.classList.contains('unbxd-as-panel-hidden')) return;

                var t = e.target;
                var field = inp.closest('.field');
                if (field && field.contains(t)) return;
                if (box.contains(t) || box === t) return;

                if (isHeaderSearchSubmitButton(t)) {
                    closeAutosuggestForSearchAction();
                    return;
                }

                hideAutosuggestPanel();
            },
            true
        );

        document.addEventListener('focusin', function (e) {
            if (!isHeaderSearchInput(e.target)) return;
            if (window.__unbxdSuppressAutosuggestPanel) return;
            reopenAutosuggestPanel();
        });

        document.addEventListener('click', function (e) {
            if (isHeaderSearchSubmitButton(e.target)) {
                closeAutosuggestForSearchAction();
                return;
            }
            if (isHeaderSearchInput(e.target) && !window.__unbxdSuppressAutosuggestPanel) {
                reopenAutosuggestPanel();
            }
        });

        forEachHeaderSearchInput(function (inpBind) {
            inpBind.addEventListener('input', function () {
                clearUnbxdAutosuggestSubmitSuppress();
                var api = window.unbxdHeaderAutosuggest;
                var query = getSearchInputQuery(inpBind);
                if (!isAutosuggestQueryReady(query, api)) {
                    hideAutosuggestPanel();
                    return;
                }
                var box = getPanel();
                if (box) box.classList.remove('unbxd-as-panel-hidden');
            });
        });

        ['Search-In-Modal-button', 'Search-In-Modal-mobile-button'].forEach(function (btnId) {
            var searchBtn = document.getElementById(btnId);
            if (!searchBtn) return;
            searchBtn.addEventListener('click', function (e) {
                var input = getSearchInput();
                if (!input) return;
                submitHeaderSearchFromInput(input, e);
            }, true);
        });

        document.addEventListener('click', function (e) {
            if (!isHeaderSearchSubmitButton(e.target)) return;
            var input = getSearchInput();
            if (!input) return;
            submitHeaderSearchFromInput(input, e);
        }, true);
    }

    document.addEventListener('DOMContentLoaded', function () {
        initHeaderAutosuggest();

        requestAnimationFrame(function () {
            ensureUnbxdAutosuggestPlacement(window.unbxdHeaderAutosuggest);
        });

        var headerSearch = document.querySelector('.header__search.desktop-search')
            || document.querySelector('.header__search');
        if (headerSearch) {
            var observer = new MutationObserver(function () {
                ensureUnbxdAutosuggestPlacement(window.unbxdHeaderAutosuggest);
            });
            observer.observe(headerSearch, { childList: true, subtree: true });
        }
    });

    /* Empty query: do not submit search form or let Unbxd treat "" as "*" (wildcard search / redirect) */
    document.addEventListener(
        'click',
        function (e) {
            var btn = e.target.closest('button.search__button');
            if (!btn) return;
            var form = btn.closest('form[role="search"]') || btn.closest('form.search');
            if (!form) return;
            var input = form.querySelector('input[name="q"]');
            if (!input) return;
            if (String(input.value || '').trim().length > 0) return;
            e.preventDefault();
            e.stopPropagation();
        },
        true
    );

    document.addEventListener(
        'submit',
        function (e) {
            var form = e.target;
            if (!(form instanceof HTMLFormElement)) return;
            if (!form.matches('form[role="search"]') && !form.classList.contains('search')) return;
            var input = form.querySelector('input[name="q"]');
            if (!input) return;
            if (String(input.value || '').trim().length > 0) return;
            e.preventDefault();
            e.stopPropagation();
        },
        true
    );

    document.addEventListener(
        'keydown',
        function (e) {
            if (e.key !== 'Enter' && e.keyCode !== 13) return;
            var t = e.target;
            if (!t || t.getAttribute('name') !== 'q') return;
            if (HEADER_SEARCH_INPUT_IDS.indexOf(t.id) === -1) return;
            submitHeaderSearchFromInput(t, e);
        },
        true
    );

    function isAutosuggestTextSuggestionNode(node) {
        if (!node || !node.dataset) return false;
        return KEYWORD_SUGGESTION_DOCTYPES.indexOf(node.dataset.doctype) !== -1;
    }

    document.addEventListener('mousedown', function (e) {
        var suggestion = e.target.closest('.unbxd-as-keysuggestion.unx-item[data-doctype]');
        if (!isAutosuggestTextSuggestionNode(suggestion)) return;
        e.preventDefault();
    }, true);

    document.addEventListener('mouseup', function (e) {
        var suggestion = e.target.closest('.unbxd-as-keysuggestion.unx-item[data-doctype]');
        if (!isAutosuggestTextSuggestionNode(suggestion)) return;

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        fireUnbxdAutosuggestSuggestionSearch(suggestion);

        setTimeout(function () {
            navigateToSuggestion(suggestion);
        }, 0);
    }, true);

    document.addEventListener('click', function (e) {
        const viewBtn = e.target.closest('.unbxd-as-view-button');
        if (!viewBtn) return;

        const input = getActiveHeaderSearchInput();
        if (!input) return;

        const query = getSearchInputQuery(input);
        if (!query) return;

        window.location.href = buildSuggestionSearchUrl(query);
    });
})();
